<eo-file-upload-base [label]="label" [help]="help" [errors]="errors">
  <p-fileUpload
    [showUploadButton]="false"
    (onSelect)="onFilesSelect($event)"
    [files]="files"
    [multiple]="multiple"
    [styleClass]="styleClass"
    [chooseLabel]="chooseLabel"
    [chooseIcon]="chooseIcon"
    [cancelIcon]="cancelIcon"
    [cancelLabel]="cancelLabel"
    [cancelStyleClass]="cancelStyleClass"
    name="files{{ id }}[]"
    [accept]="accept"
    [maxFileSize]="maxFileSize"
    [fileLimit]="fileLimit"
    [invalidFileLimitMessageSummary]="invalidFileLimitMessageSummary"
    [invalidFileLimitMessageDetail]="invalidFileLimitMessageDetail"
  >
    <ng-template pTemplate="content">

      <!-- <ng-container *ngIf="oldFiles?.length">
        <div class="details-item mb-3" *ngFor="let value of oldFiles">
          <ng-container *ngIf="loading">
            <p-skeleton height="0.8rem" width="80%" styleClass="mb-1"></p-skeleton>
            <p-skeleton></p-skeleton>
          </ng-container>

          <ng-container *ngIf="!loading">
            <h5>
              {{ title }}
              <span *ngIf="helpTitle" class="text-xs font-italic text-blue-500 font-normal">
                {{ helpTitle }}
              </span>
              <span class="error" title="Υποχρεωτικό πεδίο" *ngIf="isRequired">*</span>
            </h5>
            <p-image
              *ngIf="fileExtention() === 'image'"
              [src]="
                value?.FileUrl ??
                value?.objectURL?.changingThisBreaksApplicationSecurity
              "
              [alt]="value?.UploadedFileName ?? value?.name"
              [preview]="true"
              width="100"
              styleClass="mt-2"
            ></p-image>
            <div class="flex align-items-center gap-1">
              <i
                class="pi pi-{{ fileExtention() }} mt-1"
                [ngStyle]="{
                  color: severity
                    ? getColorBySeverity()
                    : !value?.UploadedFileName && !value?.name
                    ? 'var(--red-400)'
                    : 'var(--blue-600)'
                }"
              ></i>
              <p
                *ngIf="!value?.UploadedFileName && !value?.name"
                class="mt-1"
                [ngStyle]="{
                  color: severity ? getColorBySeverity() : 'var(--red-400)'
                }"
                style="font-weight: 600"
              >
                Δεν ορίστηκε αρχείο
              </p>
              <a *ngIf="value?.FileUrl" [href]="value?.FileUrl" target="_blank">
                {{ value?.UploadedFileName ?? value?.name }}
              </a>
              <span *ngIf="!value?.FileUrl">
                {{ value?.UploadedFileName ?? value?.name }}
              </span>
            </div>
          </ng-container>
        </div> -->

      <!-- <ul *ngIf="files?.length">
        <li *ngFor="let file of files">
          {{ file.name }} - {{ file.size }} bytes
        </li>
      </ul> -->
      <!-- <div *ngIf="hasFiles()" class="border-1 border-200 my-4"></div> -->
      <div class="flex align-items-center justify-content-center flex-column">
        <i class="pi pi-cloud-upload p-2 text-4xl text-400"></i>
        <p class="m-0 text-sm">{{ dragAndDropSummary }}</p>
        <p class="m-0 text-xs">{{ dragAndDropDescription }}</p>
      </div>
    </ng-template>
  </p-fileUpload>
</eo-file-upload-base>
